<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="type == '按仓库'">
            <label class="weui-form-preview__label">仓库编号</label>
            <span class="weui-form-preview__value">{{initData.pd_whcode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="type == '按仓库'">
            <label class="weui-form-preview__label">仓库名称</label>
            <span class="weui-form-preview__value">{{initData.pd_whname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最小订购数量</label>
            <span class="weui-form-preview__value">{{initData.pr_moq}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最小包装数</label>
            <span class="weui-form-preview__value">{{initData.pr_zxbzs}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">昨日库存结余</label>
            <span class="weui-form-preview__value">{{initData.onhand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">昨日出货数量</label>
            <span class="weui-form-preview__value">{{initData.outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">在途数量</label>
            <span class="weui-form-preview__value">{{initData.poqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">日销售预测</label>
            <span class="weui-form-preview__value">{{initData.day_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">日需求预测</label>
            <span class="weui-form-preview__value">{{initData.day_needqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">日采购需求预测</label>
            <span class="weui-form-preview__value">{{initData.day_purcneedqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购周期（天）</label>
            <span class="weui-form-preview__value">{{initData.pr_leadtime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上周库存结余</label>
            <span class="weui-form-preview__value">{{initData.week_onhand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上周入库数</label>
            <span class="weui-form-preview__value">{{initData.week_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上周出货数</label>
            <span class="weui-form-preview__value">{{initData.week_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本周出货数</label>
            <span class="weui-form-preview__value">{{initData.week_thissend}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">周销售预测</label>
            <span class="weui-form-preview__value">{{initData.week_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">周需求预测</label>
            <span class="weui-form-preview__value">{{initData.week_needqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">周采购需求预测</label>
            <span class="weui-form-preview__value">{{initData.week_purcneedqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上月库存结余</label>
            <span class="weui-form-preview__value">{{initData.month_onhand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上月入库数</label>
            <span class="weui-form-preview__value">{{initData.month_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">上月出货数</label>
            <span class="weui-form-preview__value">{{initData.month_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月出货数</label>
            <span class="weui-form-preview__value">{{initData.month_thissend}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月销售预测</label>
            <span class="weui-form-preview__value">{{initData.month_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月需求预测</label>
            <span class="weui-form-preview__value">{{initData.month_needqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月采购需求预测</label>
            <span class="weui-form-preview__value">{{initData.month_purcneedqty}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object,
    type: String
  },
  data() {
    return {

    }
  },
  methods: {

  },
};
</script>